<template>
	<div>
		<div class="event-card" v-if="!loading && item">
			<div class="image" v-if="item.image" :style="`background-image:url(${item.image.url})`"></div>
			<div class="data">
				<h2 class="title">{{ item.name }}</h2>
				<div class="description"></div>

				<div class="data-set mt-3">
					<i class="icon icon-calendar"></i>

					<div class="info">
						<h2>{{ item.startAt | moment("ddd DD [de] MMMM, YYYY") }}</h2>
						<p>{{ item.startAt | moment("HH:mm") }} - {{ item.endAt | moment("HH:mm") }}</p>
					</div>
				</div>

				<div class="data-set">
					<i class="icon icon-map-marker"></i>
					<div class="info">
						<h2>{{ item.location.name }}</h2>
						<p>
							{{ item.location.address }},
							<span>{{ item.location.locality.name }}, </span>
							<span>{{ item.location.locality.region.name }}</span>
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import gql from "graphql-tag"

export default {
	name: "EventCard",
	props: {
		eventId: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			item: null,
			loading: false
		}
	},
	async beforeMount() {
		console.log("beforeMount")
		this.loading = true
		this.item = await this.load()
		this.loading = false
	},
	methods: {
		async load() {
			return this.$apollo
				.query({
					query: gql`
						query($id: ID!) {
							event(id: $id) {
								id
								name
								startAt
								endAt
								description
								image {
									id
									type
									filename
									url
									urlThumb
								}
								location {
									id
									name
									locality {
										name
										region {
											name
										}
									}
									address
									latlng {
										lat
										lng
									}
								}
								status
								statusText
								statusClass
							}
						}
					`,
					variables: { id: this.eventId },
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					return data.event
				})
				.catch(() => {})
		}
	}
}
</script>

<style scoped lang="scss">
.event-card {
	background-color: #fff;
	border-radius: 8px;
	display: flex;

	.image {
		width: 180px;
		height: 180px;

		border-radius: 8px;
		margin-right: 12px;

		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
	}
	.data {
		padding: 16px;

		h2.title {
			font-size: 1.8rem;
		}
	}

	.data-set {
		display: flex;
		align-items: flex-start;
		justify-self: start;

		.icon {
			width: 18px;
			flex-shrink: 0;
			font-size: 1.3rem;
			color: #bbb;
			margin-top: 3px;
			margin-right: 18px;
		}
		.info {
			flex-grow: 1;

			h2 {
				font-size: 1.1em;
			}
			p {
				font-size: 0.95em;
				color: #666;
			}
		}
	}
}
</style>
